(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brightcode-product-video-viewport"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcProductVideoV9) return;
    window.__bcProductVideoV9 = true;

    var reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function videoOf(node) {
      var list = node.querySelectorAll('video');
      for (var i = 0; i < list.length; i++) {
        if (!list[i].closest('template')) return list[i];
      }
      return null;
    }

    /** Only one PDP surface may attach/buffer a given media src at a time */
    var activeSurfaceBySrc = Object.create(null);

    function mediaKey(node) {
      var v = videoOf(node);
      if (v && (v.dataset.bcVideoSrc || v.dataset.pendingSrc)) {
        return v.dataset.bcVideoSrc || v.dataset.pendingSrc;
      }
      return node.getAttribute('data-media-id') || node.id || '';
    }

    function attachDeferredSrc(v) {
      if (!v) return;
      var src = v.dataset.bcVideoSrc || v.dataset.pendingSrc || '';
      if (!src) return;
      if (v.dataset.currentSrc === src && (v.getAttribute('src') || v.src)) return;
      v.preload = 'none';
      v.setAttribute('preload', 'none');
      v.dataset.currentSrc = src;
      v.src = src;
      try {
        v.load();
      } catch (e) {}
    }

    function detachDeferredSrc(v) {
      if (!v) return;
      try {
        v.pause();
      } catch (e) {}
      if (v.getAttribute('src') || v.src) {
        v.removeAttribute('src');
        try {
          v.load();
        } catch (e2) {}
      }
      v.dataset.currentSrc = '';
    }

    function toggleOf(node) {
      return (
        node.querySelector(':scope > [ref="toggleMediaButton"]') ||
        node.querySelector(':scope > .video-interaction-hint') ||
        node.querySelector('[ref="toggleMediaButton"]') ||
        node.querySelector('.video-interaction-hint')
      );
    }

    function setIcons(node, playing) {
      var btn = toggleOf(node);
      if (!btn) return;
      btn.classList.remove('hidden');
      btn.setAttribute('aria-hidden', 'false');
      var play = btn.querySelector('.icon-play');
      var pauseIcon = btn.querySelector('.icon-pause');
      if (play) play.classList.toggle('hidden', !!playing);
      if (pauseIcon) pauseIcon.classList.toggle('hidden', !playing);
      if (typeof node.isPlaying !== 'undefined') node.isPlaying = !!playing;
    }

    function isVisibleSurface(node) {
      if (!node || !node.isConnected) return false;
      if (node.closest('dialog') && !node.closest('dialog[open]')) return false;
      var el = node;
      while (el && el !== document.documentElement) {
        var cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden') return false;
        el = el.parentElement;
      }
      return true;
    }

    function galleryShell(node) {
      return (
        node.closest('slideshow-container') ||
        node.closest('media-gallery') ||
        node.closest('.product-information__media') ||
        node
      );
    }

    function inViewport(node) {
      var el = galleryShell(node);
      var r = el.getBoundingClientRect();
      if (r.width < 8 || r.height < 8) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      return visible / r.height >= 0.15;
    }

    function slideActive(node) {
      var slide = node.closest('slideshow-slide');
      if (!slide) return true;
      var ss = slide.closest('slideshow-component');
      if (ss && typeof ss.current === 'number' && ss.slides) {
        var slides = ss.slides;
        var idx = -1;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i] === slide) {
            idx = i;
            break;
          }
        }
        if (idx >= 0) return idx === ss.current;
      }
      return slide.getAttribute('aria-hidden') !== 'true';
    }

    function shouldPlay(node) {
      return isVisibleSurface(node) && slideActive(node) && inViewport(node);
    }

    function ensureVideo(node) {
      if (!isVisibleSurface(node)) return Promise.resolve(null);

      var key = mediaKey(node);
      if (key && activeSurfaceBySrc[key] && activeSurfaceBySrc[key] !== node) {
        /* Another visible surface already owns this src — steal only if that one hid */
        if (isVisibleSurface(activeSurfaceBySrc[key])) {
          return Promise.resolve(videoOf(node));
        }
      }

      var v = videoOf(node);
      if (v) {
        attachDeferredSrc(v);
        if (key) activeSurfaceBySrc[key] = node;
        return Promise.resolve(v);
      }
      return new Promise(function (resolve) {
        if (typeof node.showDeferredMedia === 'function') node.showDeferredMedia();
        else if (typeof node.loadContent === 'function') node.loadContent(false);
        var n = 0;
        (function wait() {
          n += 1;
          var found = videoOf(node);
          if (found) {
            attachDeferredSrc(found);
            if (key) activeSurfaceBySrc[key] = node;
            resolve(found);
            return;
          }
          if (n > 50) resolve(null);
          else requestAnimationFrame(wait);
        })();
      });
    }

    function saveTime(node) {
      var v = videoOf(node);
      if (v && !isNaN(v.currentTime)) node._bcTime = v.currentTime;
    }

    function restoreTime(node, v) {
      if (!v || typeof node._bcTime !== 'number') return;
      try {
        if (Math.abs(v.currentTime - node._bcTime) > 0.2) v.currentTime = node._bcTime;
      } catch (e) {}
    }

    function play(node, force) {
      if (reduceMotion) return;
      if (node._bcUserPaused && !force) return;
      if (!force && !shouldPlay(node)) {
        setIcons(node, false);
        return;
      }

      var vNow = videoOf(node);
      if (vNow && !vNow.paused && (vNow.getAttribute('src') || vNow.src)) {
        node._bcPlaying = true;
        if (force) node._bcUserPaused = false;
        setIcons(node, true);
        return;
      }

      /* Instant icon feedback on user tap */
      if (force) {
        node._bcUserPaused = false;
        setIcons(node, true);
      }

      var token = (node._bcPlayToken || 0) + 1;
      node._bcPlayToken = token;

      ensureVideo(node).then(function (v) {
        if (node._bcPlayToken !== token) return;
        if (node._bcUserPaused && !force) return;
        if (!force && !shouldPlay(node)) {
          setIcons(node, false);
          return;
        }
        if (!v) {
          setIcons(node, false);
          return;
        }
        restoreTime(node, v);
        v.muted = true;
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () {
            setIcons(node, false);
            node._bcPlaying = false;
          });
        }
        node._bcPlaying = true;
        setIcons(node, true);
      });
    }

    function pause(node, user) {
      node._bcPlayToken = (node._bcPlayToken || 0) + 1;
      saveTime(node);
      var v = videoOf(node);
      if (v && !v.paused) v.pause();
      node._bcPlaying = false;
      if (user) node._bcUserPaused = true;
      setIcons(node, false);
      /* Release buffer when surface is hidden so duplicate galleries do not keep downloading */
      if (!isVisibleSurface(node) && v) {
        var key = mediaKey(node);
        if (key && activeSurfaceBySrc[key] === node) delete activeSurfaceBySrc[key];
        detachDeferredSrc(v);
      }
    }

    function sync(node) {
      if (reduceMotion) {
        setIcons(node, false);
        return;
      }
      if (!isVisibleSurface(node)) return;

      var want = shouldPlay(node);
      var v = videoOf(node);
      var playing = !!(v && !v.paused);

      if (want) {
        if (node._bcUserPaused) {
          setIcons(node, false);
          return;
        }
        if (playing) {
          node._bcPlaying = true;
          setIcons(node, true);
          return;
        }
        play(node, false);
      } else if (playing || node._bcPlaying) {
        pause(node, false);
      } else {
        setIcons(node, false);
      }
    }

    function queueSync(node, delay) {
      if (node._bcSyncTimer) clearTimeout(node._bcSyncTimer);
      node._bcSyncTimer = setTimeout(function () {
        node._bcSyncTimer = null;
        sync(node);
      }, typeof delay === 'number' ? delay : 40);
    }

    function bindToggle(node) {
      if (node.dataset.bcToggleV9 === '1') return;
      node.dataset.bcToggleV9 = '1';

      node.toggleMedia = function () {
        var v = videoOf(node);
        if (v && !v.paused) pause(node, true);
        else play(node, true);
      };

      var btn = toggleOf(node);
      if (!btn || !btn.parentNode) return;

      var clone = btn.cloneNode(true);
      clone.classList.remove('hidden');
      clone.removeAttribute('on:click');
      clone.removeAttribute('on:click');
      clone.setAttribute('aria-hidden', 'false');
      btn.parentNode.replaceChild(clone, btn);

      clone.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          node.toggleMedia();
        },
        true
      );
    }

    function bind(node) {
      if (!node || node.dataset.bcBoundV9 === '1') return;
      node.dataset.bcBoundV9 = '1';
      node._bcUserPaused = false;
      node._bcPlaying = false;
      bindToggle(node);
      setIcons(node, false);

      if (reduceMotion || !isVisibleSurface(node)) return;

      var shell = galleryShell(node);
      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(
          function () {
            queueSync(node, 60);
          },
          { threshold: [0, 0.15, 0.35, 0.6, 1] }
        ).observe(shell);
      }

      var ss = node.closest('slideshow-component');
      if (ss) {
        /* ss.current updates immediately — sync now, then once after settle */
        ss.addEventListener('slideshow:select', function () {
          sync(node);
          requestAnimationFrame(function () {
            sync(node);
          });
          queueSync(node, 280);
        });
      }

      document.addEventListener('media:started-playing', function (ev) {
        var src = ev && ev.detail && ev.detail.resource;
        if (!src || src === node) return;
        if (src.closest('dialog[open]')) {
          pause(node, false);
          return;
        }
        /* Hidden duplicate media stole play — reclaim */
        if (!isVisibleSurface(src) && !node._bcUserPaused && shouldPlay(node)) {
          queueSync(node, 20);
        }
      });

      window.addEventListener(
        'scroll',
        function (ev) {
          var t = ev.target;
          if (
            t &&
            t !== document &&
            t !== document.documentElement &&
            t !== document.body &&
            ss &&
            ss.contains(t)
          ) {
            return;
          }
          queueSync(node, 80);
        },
        { passive: true, capture: true }
      );

      /* Delay autoplay attach so LCP image wins the first second on 4G */
      queueSync(node, 1100);
    }

    function init(scope) {
      (scope || document)
        .querySelectorAll('deferred-media[data-bc-viewport-autoplay]')
        .forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brightcode-size-chart-json"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcSizeChartInitV2) return;
    window.__bcSizeChartInitV2 = true;

    function currentFit(root) {
      var active = root.querySelector('.bc-size-chart__fit-tab.is-active');
      if (active) return active.getAttribute('data-bc-sc-fit');
      return root.getAttribute('data-default-fit') || '';
    }

    function currentUnit(root) {
      var active = root.querySelector('.bc-size-chart__tab.is-active');
      if (active) return active.getAttribute('data-bc-sc-tab');
      return root.getAttribute('data-default-unit') || 'cm';
    }

    function activate(root, fit, unit) {
      var hasFits = Boolean(root.querySelector('[data-bc-sc-fit]'));

      root.querySelectorAll('[data-bc-sc-fit]').forEach(function (tab) {
        var on = tab.getAttribute('data-bc-sc-fit') === fit;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      root.querySelectorAll('[data-bc-sc-tab]').forEach(function (tab) {
        var on = tab.getAttribute('data-bc-sc-tab') === unit;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      root.querySelectorAll('[data-bc-sc-panel]').forEach(function (panel) {
        var panelUnit = panel.getAttribute('data-bc-sc-panel-unit');
        var panelFit = panel.getAttribute('data-bc-sc-panel-fit');
        var unitOk = panelUnit === unit;
        var fitOk = hasFits ? panelFit === fit : true;
        var on = unitOk && fitOk;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
    }

    document.addEventListener('click', function (e) {
      var fitTab = e.target && e.target.closest && e.target.closest('[data-bc-sc-fit]');
      var unitTab = e.target && e.target.closest && e.target.closest('[data-bc-sc-tab]');
      if (!fitTab && !unitTab) return;

      var root = (fitTab || unitTab).closest('[data-bc-size-chart]');
      if (!root) return;
      e.preventDefault();

      var fit = fitTab ? fitTab.getAttribute('data-bc-sc-fit') : currentFit(root);
      var unit = unitTab ? unitTab.getAttribute('data-bc-sc-tab') : currentUnit(root);
      activate(root, fit, unit);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
